/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';
import type { Target, ValueLabel } from '../../../index';
import type { SliderProps } from '../index';
import { hasTouchEvents } from '../../../../../utils/misc';

export const roundToNearest = (numToRound: number, numToRoundTo: number) =>
  Math.round(numToRound / numToRoundTo) * numToRoundTo;

type SliderValue = {
  min: number;
  max: number;
};

export default class SliderModel {
  value: SliderValue;

  minAllowed: number;

  maxAllowed: number;

  bulletSize: number;

  onUpdate: (e: Target) => Promise<void>;

  name: string;

  label?: string | any;

  roundTo: number;

  valueLabel?: string | ValueLabel;

  hideMin?: boolean;

  className?: string;

  valuesOnBottom?: boolean;

  disabled?: boolean;

  diagram?: JSX.Element;

  constructor(props: SliderProps) {
    const {
      minAllowed,
      maxAllowed,
      bulletSize,
      onUpdate,
      name,
      value,
      label,
      roundTo,
      valueLabel,
      hideMin,
      className,
      valuesOnBottom,
      diagram,
      disabled,
    } = props;

    this.value = value;
    this.minAllowed = minAllowed;
    this.maxAllowed = maxAllowed;
    this.bulletSize = bulletSize;
    this.onUpdate = onUpdate;
    this.name = name;
    this.label = label;
    this.roundTo = roundTo;
    this.valueLabel = valueLabel;
    this.hideMin = hideMin;
    this.className = className;
    this.valuesOnBottom = valuesOnBottom;
    this.diagram = diagram;
    this.disabled = disabled;
  }

  get isMobile(): boolean {
    return hasTouchEvents();
  }

  getXPos(e: any): number {
    if (canUseDOM) return hasTouchEvents() && e.touches ? e.touches[0].pageX : e.pageX - window.pageXOffset;
    return 0;
  }

  getContainerEl(e: any, sliderRef: any, hideMin?: boolean): { dataType: string; clickX: number } {
    if (canUseDOM) {
      const xPos = hasTouchEvents() && e.touches ? e.touches[0].pageX : e.pageX - window.pageXOffset;
      const yPos = hasTouchEvents() && e.touches ? e.touches[0].pageY : e.pageY - window.pageYOffset;

      if (xPos && yPos) {
        let el = document.elementFromPoint(xPos, yPos);
        const dataType = el && el.getAttribute('data-type');
        el = !dataType ? sliderRef.current : el;

        if (el) {
          const clickX = xPos - el.getBoundingClientRect().x;

          return { dataType: dataType || 'bar', clickX };
        }

        return { dataType: dataType || 'bar', clickX: 0 };
      }

      return { dataType: 'bar', clickX: 0 };
    }

    return { dataType: 'bar', clickX: 0 };
  }

  getElementsData(sliderRef: any): { x: number; width: number } {
    const { x, width } = sliderRef.current.getBoundingClientRect();
    return { x, width };
  }

  sizeToVal(size: number, barSize: number, maxAllowed: number, roundTo: number, minAllowed: number): number {
    return roundToNearest(Math.ceil(((size - 0) / (barSize - 0)) * (maxAllowed - minAllowed) + minAllowed), roundTo);
  }

  valToSize(val: number, barSize: number, maxAllowed: number, bulletSize: number, minAllowed: number): number {
    const size = ((val - minAllowed) * (barSize - bulletSize)) / (maxAllowed - minAllowed);
    return size;
  }
}
